import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { LoaderService } from "../../../core/services/loader.service";
import { Editor, EditorModule } from "primeng/editor";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { UpdateNotificationEmailDto } from "../../../core/models/project-workflow/updateNotificationEmailDto";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { AddProjectWorkFlowLinesTemplatesRequestDto } from "../../../core/models/project-workflow/addProjectWorkFlowLinesTemplatesRequestDto";
import { Select, SelectChangeEvent, SelectModule } from "primeng/select";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { DialogModule } from "primeng/dialog";
import { OverlayPanelModule } from "primeng/overlaypanel";

@UntilDestroy()
@Component({
  selector: "jni-workflow-line-templates-form",
  templateUrl: "./workflow-line-templates-form.component.html",
  styleUrls: ["./workflow-line-templates-form.component.scss"],
  imports: [
    ButtonModule,
    CardModule,
    InputTextModule,
    DialogModule,
    ReactiveFormsModule,
    SelectModule,
    FormsModule,
    EditorModule,
    OverlayPanelModule,
  ],
})
export class WorkflowLineTemplatesFormComponent {
  @Input() displayAddNewTemplateModal!: boolean;
  @Output() closeAndRefreshTemplatesGridEvent = new EventEmitter();
  @Output() closeAddUpdateTemplateDialogEvent = new EventEmitter();
  parentForm: FormGroup;
  selectionStart = 0;
  selectionLength = 0;
  @ViewChild("tagSelector") tagSelector!: Select;
  lastSelectedTagOption: string | null = null;
  @Input() notificationEmailData = {} as UpdateNotificationEmailDto;
  tagValue: string | null = "";

  tagList = [
    "$Owner$",
    "$Client$",
    "$JobName$",
    "$ProjectNumber$",
    "$TrackingNumber$",
    "$CompanyName$",
    "$NickName$",
  ];
  constructor(
    private _formBuilder: FormBuilder,
    private _toastr: JniToastrService,
    private _loaderService: LoaderService,
    private _productionWorkflowService: ProjectWorkflowService
  ) {
    this.parentForm = this._formBuilder.group({
      id: [0],
      title: ["", Validators.required],
      tags: [""],
      description: ["", Validators.required],
    });
  }

  clearForm() {
    this.parentForm.patchValue({
      id: 0,
      title: "",
      tags: "",
      description: "",
    });
  }

  saveAddNewTemplate() {
    this._loaderService.setLoaderState(true);

    const obj = this.parentForm.getRawValue();
    const request: AddProjectWorkFlowLinesTemplatesRequestDto = {
      id: 0,
      templateType: "ProjectWorkFlowLinesTemplates",
      title: obj.title,
      description: obj.description,
    };
    this._productionWorkflowService
      .AddProjectWorkFlowLinesTemplates(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              res.message || "Template added successfully"
            );
            this.clearForm();
            this.closeAndRefreshTemplatesGridEvent.emit();
            this.closeAddNewTemplateDialog();
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error Occured While adding the template"
            );
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            res.message || "Error Occured While adding the template"
          );
        },
      });
  }

  /* eslint-disable @typescript-eslint/no-unsafe-call */
  onChangeAddTag(editorRef: Editor, event: SelectChangeEvent) {
    if (!editorRef) return;

    const editor = editorRef.getQuill();
    const selection = editor.getSelection();
    const textLength = editor.getLength();

    if (!selection && this.selectionStart === 0) {
      this.selectionStart = textLength;
      this.selectionLength = 0;
    }

    const position = this.selectionStart;
    const length = this.selectionLength;
    if (length > 0) {
      editor.deleteText(position, length);
    }
    editor.insertText(this.selectionStart, event.value ?? "");

    editor.setSelection(position + event.value.length);
    this.lastSelectedTagOption = event.value;
    this.tagValue = null;
    //this.tagSelector.setValue(null);
    this.selectionStart = position + event.value.length;
    this.selectionLength = 0;
    this.notificationEmailData.content = editor.root.innerHTML;
  }

  getCursorPostion(editorRef: Editor) {
    const editor = editorRef.getQuill();
    const selection = editor.getSelection();
    if (selection) {
      this.selectionStart = selection?.index ?? 0;
      this.selectionLength = selection?.length ?? 0;
    }
  }

  closeAddNewTemplateDialog() {
    this.displayAddNewTemplateModal = false;
    this.closeAddUpdateTemplateDialogEvent.emit();
  }
}
